import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import AloModal from '../YogaUI/alo-ui/AloModal';
import { toJS } from 'mobx';
import { loyaltyState } from '../../../../sections/header/Cart/components/Loyalty/loyaltyState';
import { qrCodeModalState, closeQRCodeModal } from './state';
import { getLoyaltyTierLogo } from 'src/scripts/sections/header/Cart/components/Loyalty/loyaltyUtils';
import { getLoyaltyBlockedStatus } from 'src/scripts/templates/_shared/loyaltyBlockedStatus';
import QRCodeDisplay from './QRCodeDisplay';
import './styles.scss';

let QRCodeModal = () => {
  const [isUserBlocked, setIsUserBlocked] = useState(false);
  const loyaltyTier = toJS(loyaltyState.tier);
  const tierImageUrl = getLoyaltyTierLogo({ tier: loyaltyTier, isCompact: false, isMobile: false });
  const customerName = qrCodeModalState.data?.customerName || 'there';
  const customerEmail = qrCodeModalState.data?.customerEmail || '';

  useEffect(() => {
    const checkBlockedStatus = async () => {
      const blocked = await getLoyaltyBlockedStatus();
      setIsUserBlocked(blocked);
    };
    checkBlockedStatus();
  }, []);

  if (!customerEmail) {
    return null;
  }

  return (
    <AloModal
      open={qrCodeModalState.isOpen}
      onClose={closeQRCodeModal}
      showCloseButton={true}
      wrapperClass="qr-code-modal"
      containerClass="qr-code-modal-container"
    >
      <div className="qr-code-modal-content">
        {tierImageUrl && !isUserBlocked && (
          <div className="qr-code-modal-tier">
            <img src={tierImageUrl} alt={loyaltyTier.length > 0 ? loyaltyTier : 'tier1'} className="tier-logo" />
          </div>
        )}

        <div className="qr-code-modal-info">
          <div className="customer-section">
            <p className="label">NAME</p>
            <p className="value">{customerName}</p>
          </div>

          <div className="customer-section">
            <p className="label">MEMBER EMAIL</p>
            <p className="value">{customerEmail}</p>
          </div>
        </div>

        <div className="qr-code-modal-qr">
          <div className="qr-code-wrapper">
            <QRCodeDisplay
              email={customerEmail}
              width={247}
              className="modal-qr-display"
              alt="Member QR Code"
              loadingText="Generating QR code..."
              errorText="Failed to generate QR code"
            />
            <p>Share QR code in-store for easy account lookup</p>
          </div>
        </div>
      </div>
    </AloModal>
  );
};

QRCodeModal = observer(QRCodeModal);
export default QRCodeModal;
